export default __webpack_public_path__ + "static/media/longTail.a5d6173f.jpeg";